export const ONLY_CUSTOM_BUTTONS = 'onlyCustomButtons';
